import { UseFormReturnType } from "@mantine/form"
import { MapPin, Path } from "@phosphor-icons/react"
import { Checkbox, TextArea } from "@vesatogo/grass-core"
import { useState } from "react"
import AddressForm, { AddressFormProps } from "~/components/Map/AddressForm"
import { Mohadi } from "~/components/Map/location.data"

export type AddressComponentType = AddressFormProps & {
  form: UseFormReturnType<any, (values: any) => any>
  group?: any
  userInitialAddress?: any
  groupAddressAccessKey?: any
  checkboxDisabled?: boolean
  showRawAddress?: boolean
  concise?: boolean
}

export const Address = ({
  form,
  group,
  userInitialAddress,
  checkboxDisabled = false,
  addressKey = "address",
  groupAddressAccessKey = "address",
  showRawAddress = false,
  children,
  concise,
  ...props
}: AddressComponentType) => {
  const [conciseView, setConciseView] = useState(concise)

  const { getInputProps, values: state, setValues: setState } = form
  const groupAddress = group?.[groupAddressAccessKey]
  const groupAddressKey = JSON.stringify(groupAddress?.location?.coordinates)
  const userAddressKey = JSON.stringify(
    state?.[addressKey]?.location?.coordinates
  )

  return (
    <AddressForm
      getInputProps={getInputProps}
      setValues={setState}
      addressKey={addressKey}
      showRawAddress={showRawAddress}
      {...props}
      conciseView={conciseView}
    >
      {conciseView && showRawAddress ? (
        <div className="flex col-span-2 text-sm items-center text-gray-700">
          <div className="flex items-start">
            <MapPin weight="fill" size={22} className="text-green mr-1" />
          </div>
          {state?.current_address?.raw_address || "Raw Address"}
        </div>
      ) : (
        <div className="col-span-2">
          <TextArea
            label="Detailed address"
            className="w-full"
            {...getInputProps(`${addressKey}.raw_address`)}
            disabled={props.disabled}
          />
        </div>
      )}

      {conciseView && state?.current_address?.sub_region && (
        <div className="flex text-sm items-center text-gray-700">
          <Path size={22} weight="fill" className="text-green mr-1" />
          {state?.current_address?.sub_region?.name}
        </div>
      )}
      {conciseView && (
        <div className="flex text-sm items-center text-gray-700 pl-7 -mt-3">
          {`${state?.current_address?.village}, ${state?.current_address?.taluka}, ${state?.current_address?.district}, ${state?.current_address?.state}`}
        </div>
      )}
      {group && (
        <div className="col-span-2">
          <Checkbox
            disabled={checkboxDisabled}
            onChange={value => {
              if (value) {
                setState({
                  ...state,
                  [addressKey]: groupAddress,
                })
              } else {
                setState({
                  ...state,
                  [addressKey]:
                    userInitialAddress &&
                    JSON.stringify(
                      userInitialAddress?.location?.coordinates
                    ) !== groupAddressKey
                      ? userInitialAddress
                      : Mohadi,
                })
              }
            }}
            checked={groupAddressKey === userAddressKey}
            label={`Same as group (${
              group?.name || group?.first_name
            }) address`}
          />
        </div>
      )}
    </AddressForm>
  )
}
